/**
 * Created by joerg on 13.06.17.
 */
import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import InputModel from '../models/InputModel'
import numeral from 'numeral/numeral'
import 'numeral/locales'
import {observable} from 'mobx';


@observer
export default class InputComponent extends React.Component {
    @observable mstate = null;
    constructor(props){
        super(props);
        this.mstate = {isfocused:false,val:this._formatToString(this.props.inputModel.value)}
    }

    componentWillReact() {
        if(!this.mstate.isfocused){

            this.mstate = {isfocused:false,val:this._formatToString(this.props.inputModel.value)}
        }
        //console.log("I will re-render, ",this.props.inputModel.value);
    }
    _onChange(e,entry){
        this.mstate = {isfocused:true,val:e.target.value};
    }
    _onKeyDown(event){
        if (event.charCode == 13) {
            event.preventDefault();
            event.stopPropagation();
            event.target.blur();
        }
    }
    _onBlur(e,entry) {
        if (!this.props.inputModel.isText) {

            numeral.locale('de');
            var num = numeral(e.target.value)
            this.props.inputModel.value = num.value();
        }else{
            this.props.inputModel.value = e.target.value
        }
        this.mstate = {isfocused:false,val:this._formatToString(this.props.inputModel.value)};
    }
    _onFocus(e){
        this.mstate = {isfocused:true,val:this._formatToString(this.props.inputModel.value)};
    }

    _formatToString(v){
        if (!this.props.inputModel.isText) {
            numeral.locale('de');
            if(this.props.inputModel.isdecimal){
                return numeral(v).format('0,0.00');
                //pat = "[0-9]*+([\,][0-9]{0,2})"
            }
            return  numeral(v).format('0,0');
        }
        return v;
    }


    render(){
        var self = this;
        var leftstyles = (this.props.setLeftAddon===false)?'':'left-addon';
        var rightstyles = (this.props.setRightAddon===false)?'':'right-addon';
        let ptypes = this.props.inputClasses || ['size-input'];
        numeral.locale('de');
        //var fval;
        //var pat = "[0-9\s]*";

        return(
            <div className="input-group" style={{width:'100%',display:((this.props.inputModel.isHidden)?'none':'table')}}>
                <div className={"input-group-addon "+leftstyles} dangerouslySetInnerHTML={{__html: this.props.inputModel.title}}></div>
                <input type="text"  className={"form-control numberinput "+ptypes.join(' ')}
                       disabled={this.props.inputModel.disabled} value={self.mstate.val} onFocus={(e)=>{self._onFocus(e)}} onKeyPress={(k)=>{self._onKeyDown(k)}} onChange={(e)=>{self._onChange(e)}} onBlur={(e)=>{self._onBlur(e)}} />
                <div className={"input-group-addon "+rightstyles} dangerouslySetInnerHTML={{__html: this.props.inputModel.einheit}}></div>
            </div>
        )
    }
}
InputComponent.propTypes = {
    inputModel: PropTypes.instanceOf(InputModel).isRequired,
    setLeftAddon:PropTypes.bool,
    setRightAddon:PropTypes.bool,
    inputClasses:PropTypes.array
};


// WEBPACK FOOTER //
// ./src/components/InputComponent.js